export const GLOBAL_CHART = {
  //chart view

  "Chart.Bg.Color": {
    ref: "Color.White"
  },

  "Chart.Overflow": {
    defaultValue: "auto"
  },

  "Chart.Height": {
    defaultValue: "300px"
  },
  "Chart.Width": {
    defaultValue: "300px"
  },
  "Chart.Min.Height": {
    defaultValue: "300px"
  },
  "Chart.Min.Width": {
    defaultValue: "300px"
  },
  "Chart.Max.Height": {
    defaultValue: "unset"
  },
  "Chart.Max.Width": {
    defaultValue: "unset"
  },

  "Chart.Margin.Top": {
    defaultValue: "0"
  },
  "Chart.Margin.Right": {
    defaultValue: "0"
  },
  "Chart.Margin.Bottom": {
    defaultValue: "0"
  },
  "Chart.Margin.Left": {
    defaultValue: "0"
  },

  "Chart.Padding.Top": {
    defaultValue: "0"
  },
  "Chart.Padding.Right": {
    defaultValue: "0"
  },
  "Chart.Padding.Bottom": {
    defaultValue: "0"
  },
  "Chart.Padding.Left": {
    defaultValue: "0"
  },

  "Chart.Border.Style": {
    defaultValue: "solid"
  },
  "Chart.Border.Color": {
    defaultValue: "transparent"
  },

  "Chart.Border.Left.Width": {
    defaultValue: "0"
  },
  "Chart.Border.Right.Width": {
    defaultValue: "0"
  },
  "Chart.Border.Top.Width": {
    defaultValue: "0"
  },
  "Chart.Border.Bottom.Width": {
    defaultValue: "0"
  },

  "Chart.Border.Top.Left.Radius": {
    defaultValue: "0"
  },
  "Chart.Border.Top.Right.Radius": {
    defaultValue: "0"
  },
  "Chart.Border.Bottom.Right.Radius": {
    defaultValue: "0"
  },
  "Chart.Border.Bottom.Left.Radius": {
    defaultValue: "0"
  },

  "Chart.Shadow": {
    defaultValue: "none"
  }
};
